import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

const Temoignages = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 pb-10">
      <section className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.3em] text-primary mb-5">Témoignages</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-light leading-tight">Des mots qui nous portent</h1>
          <p className="mt-6 text-lg text-foreground/70 leading-relaxed">
            Familles, aidants et professionnels partagent l'histoire de leurs objets et les moments qu'ils ont fait naître.
          </p>
        </Reveal>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal delay={0.15}>
          <div className="mt-10 rounded-[2.5rem] overflow-hidden border border-warm/25 shadow-[0_20px_60px_rgb(0,0,0,0.08)] grain" data-testid="temoignages-banner">
            <img src="/affiche-temoignages.jpg" alt="Une famille lisant des lettres de remerciement autour du thé, veillée par une gardienne" className="w-full h-auto block" />
          </div>
        </Reveal>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
        <div className="divide-y divide-border">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.06}>
              <figure data-testid={`testimonial-${t.id}`} className="py-14 first:pt-0">
                <p className="font-serif-display text-2xl sm:text-3xl font-light leading-snug text-foreground/90">
                  <span className="text-primary">“</span>{t.quote}<span className="text-primary">”</span>
                </p>
                <figcaption className="mt-6 flex items-center gap-4">
                  <span className="w-10 h-px bg-primary" />
                  <div>
                    <span className="font-medium">{t.author}</span>
                    <span className="text-muted-foreground text-sm"> — {t.role}</span>
                  </div>
                  <span className="ml-auto text-xs uppercase tracking-[0.2em] text-secondary-foreground/60">{t.condition}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <h2 className="font-serif-display text-3xl sm:text-4xl font-light">Une expérience à partager ?</h2>
          <p className="mt-4 text-foreground/70">Nous serions honorés de recevoir votre témoignage.</p>
          <Link to="/contact" data-testid="testimonials-cta" className="inline-block mt-7 rounded-full border border-border px-8 py-4 hover:bg-accent transition-colors">Nous écrire</Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Temoignages;
